import React, { Component } from "react";
import { Dialog } from "@material-ui/core";
import "./NewTemplateDaysDialog.scss";
import i18n from "../../i18n";

class NewTemplateDaysDialog extends Component {
  handleGoRatePlan = () => {
    this.props.history.push("/payment");
  };
  render() {
    const { isMobile, newTemplateRemainDays, open, onClose } = this.props;

    return (
      <Dialog
        open={open}
        onClose={onClose}
        className="new-template-days-dialog"
      >
        <div className={"dialog-wrap" + (isMobile ? ' mo' : '')}>
          <div className="dialog-body">
            <span className={isMobile ? 'mo' : undefined}>
              {i18n.t("designselectpopup.new.template.alert", {
                DAYS: newTemplateRemainDays,
              })}
            </span>
            <p className={isMobile ? 'mo' : undefined}>{i18n.t("designselectpopup.new.template.payment")}</p>
            <button 
              className={isMobile ? 'mo' : undefined}
              onClick={this.handleGoRatePlan}
            >
              {`${i18n.t("designselectpopup.move.payment")}`}
              <span>&gt;</span>
            </button>
          </div>
        </div>
      </Dialog>
    );
  }
}

export default NewTemplateDaysDialog;
